import { Linking } from "react-native";

export const contactSupport = () => {
  Linking.openURL("https://wa.me/971585909711");
};


export const getDateChangeMap = (
  results: { _id: string; createdAt: number }[]
): Record<string, number> => {
  const dateChangeMap: Record<string, number> = {};
  let prevDate: string | null = null;

  // ensure ascending sort (oldest first)
  const sorted = [...results].toSorted((a, b) => a.createdAt - b.createdAt);

  for (const msg of sorted) {
    const currentDate = new Date(msg.createdAt).toISOString().split("T")[0];

    // If date changed from previous (or first message), mark this message
    if (currentDate !== prevDate) {
      dateChangeMap[msg._id] = msg.createdAt;
    }

    prevDate = currentDate;
  }

  return dateChangeMap;
};

export const getSessionStatusDisplay = (
  status: "scheduled" | "in_progress" | "completed" | "cancelled_by_parent" | "cancelled_by_admin" | "cancelled_by_tutor" | "no_show_reported_by_student" | "no_show_reported_by_tutor"
): string => {
  switch (status) {
    case "scheduled":
      return "Scheduled";
    case "in_progress":
      return "In Progress";
    case "completed":
      return "Completed";
    case "cancelled_by_parent":
      return "Cancelled by Parent";
    case "cancelled_by_admin":
      return "Cancelled by Admin";
    case "cancelled_by_tutor":
      return "Cancelled by Tutor";
    case "no_show_reported_by_student":
    case "no_show_reported_by_tutor":
      return "No Show";
    default:
      return status;
  }
};
